import React, { PropsWithChildren } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { Loader2, X } from 'lucide-react'

interface Props extends PropsWithChildren {
  isOpen: boolean
  closeModal: () => void
  isLoading?: boolean
  className?: string
}
const Modal = ({
  children,
  isOpen,
  closeModal,
  isLoading = false,
  className,
}: Props) => (
  <Dialog.Root open={isOpen}>
    <Dialog.Portal>
      <Dialog.Overlay className='DialogOverlay' />
      <Dialog.Content
        className={`DialogContent w-[312px] lg:w-[600px] ${className}`}
      >
        {isLoading && (
          <div className='absolute left-0 top-0 z-10 m-auto flex h-full w-full items-center justify-center rounded-2xl bg-[#00000072]'>
            <Loader2 className={`${isLoading ? 'animate-spin' : 'hidden'}`} />
          </div>
        )}
        <div className='relative'>
          <X
            className='absolute right-[-16px] top-[-16px] z-20 cursor-pointer'
            onClick={closeModal}
          />
          {children}
        </div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
)

export default Modal
